export function toBase64(str: string): string {
	const utf8Str = encodeURIComponent(str);
	return window.btoa(utf8Str);
}

export function makeBase64UrlSafe(base64: string): string {
	return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

export function restoreBase64FromUrlSafe(base64: string): string {
	let str = base64.replace(/-/g, '+').replace(/_/g, '/');

	while (str.length % 4) {
		str += '=';
	}

	return str;
}

export function fromBase64(base64: string): string {
	const utf8Str = window.atob(base64);
	return decodeURIComponent(utf8Str);
}

export function toBase64UrlSafe(str: string): string {
	const base64 = toBase64(str);
	return makeBase64UrlSafe(base64);
}

export function fromBase64UrlSafe(base64: string): string {
	const restoredBase64 = restoreBase64FromUrlSafe(base64);
	return fromBase64(restoredBase64);
}
